import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function MarketReportIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M17 14H7V12H17V14ZM7 18H13V16H7V18ZM14.829 1L16.9217 3H20V18C20 19.6543 18.6543 21 17 21H4V3H7.07837L9.17096 1H2V23H17C19.7568 23 22 20.7568 22 18V1H14.829ZM8 9H10V5.0498L12 3.13769L14 5.0498V9H16V4.19434L13.1543 1.47364C12.498 0.84864 11.5068 0.84571 10.8447 1.47462L8 4.19435V9.00001V9Z",
    fill: "currentColor"
  }));
}